import { InvoiceViewer as _InvoiceViewer } from "@/features/invoice-standard-review/accounting/invoice-viewer";

export const InvoiceViewer = (props: any) => {
  return <_InvoiceViewer {...props} />;
};
